import React, { useEffect } from 'react'
import * as Styles from './styles'
import { StylesProvider } from '@material-ui/core/styles'
import WebFont from 'webfontloader'

type Props = {
  children: JSX.Element
}

const Layout: React.FC<any> = (props: Props) => {
  useEffect(() => {
    loadFonts()
  }, [])

  return (
    <React.Fragment>
      <StylesProvider injectFirst>
        <Styles.Html />
        <Styles.Body />
        {props.children}
      </StylesProvider>
    </React.Fragment>
  )
}

export default Layout

const loadFonts = (): void => {
  WebFont.load({
    google: {
      families: ['Inter:400,500,600', 'Montserrat:400,500,600,700'],
    },
  })
}
